{
  "name": "hemnet-app",
  "version": "1.11.2-develop.0",
  "scripts": {
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost.sparbanken.me",
    "build": "./scripts/version.sh && ng build --output-hashing all",
    "test": "ng test --watch=false --code-coverage",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "style-lint": "stylelint  \"src/**/*.scss\" --fix",
    "watch": "ng test"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.6",
    "@angular/cdk": "^21.2.4",
    "@angular/common": "^21.2.6",
    "@angular/compiler": "^21.2.6",
    "@angular/core": "^21.2.6",
    "@angular/forms": "^21.2.6",
    "@angular/material": "^21.2.4",
    "@angular/platform-browser": "^21.2.6",
    "@angular/platform-browser-dynamic": "^21.2.6",
    "@angular/router": "^21.2.6",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^21.2.5",
    "@angular/cli": "^21.2.5",
    "@angular/compiler-cli": "^21.2.6",
    "@angular/language-service": "^21.2.6",
    "@sparbanken-syd/auth-backend": "^2.6.1",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/rt-backend": "^4.1.0",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.0.1",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.2.0",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.1.1",
    "@types/jasmine": "~6.0.0",
    "@types/node": "^24",
    "@typescript-eslint/eslint-plugin": "^8.57.2",
    "@typescript-eslint/parser": "^8.57.2",
    "angular-eslint": "^21.3.1",
    "eslint": "^9.39.2",
    "jasmine-core": "~6.1.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "postcss": "^8.5.8",
    "postcss-scss": "^4.0.9",
    "puppeteer": "^24.40.0",
    "stylelint": "^17.6.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "stylelint-scss": "^7.0.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.57.2"
  }
}
